// extracted by mini-css-extract-plugin
export var createdDate = "_io-1";
export var divider = "_io-2";
export var headerDivider = "_io-3";
export var messagesCard = "_io-0";
export var messagesContainer = "_io-7";
export var messagesContainerWrapper = "_io-4";
export var pointerCapturingButtonBoxes = "_io-a";
export var showLeftPanelButton = "_io-9";
export var showMoreButton = "_io-c";
export var showMoreButtonContainer = "_io-b";
export var summaryTitle = "_io-6";
export var systemMessageCardWrapper = "_io-d";
export var topButtons = "_io-8";
export var withPadding = "_io-5";